// extracted by mini-css-extract-plugin
export var documentation = "_ma-1";
export var menu = "_ma-0";